import type { ReactNode } from "react";
import {
  CalendarOutlined,
  ClockCircleOutlined,
  MedicineBoxOutlined,
  UserOutlined,
  WalletOutlined,
} from "@ant-design/icons";
import { E_PRESCRIPTIONS_BASE } from "../../constants/e-prescriptions";

// Single source of truth for the doctor-facing nav — both the desktop
// sidebar (sidebar.tsx) and the mobile drawer (header.tsx) render from this
// list. They used to keep two hand-written copies in sync manually, which is
// exactly how E-Prescriptions ended up on neither: the route existed, but
// nobody remembered to add the nav entry to either copy.
export interface NavItem {
  key: string;
  label: string;
  path: string;
  icon: ReactNode;
}

export const NAV_ITEMS: NavItem[] = [
  { key: "appointments", label: "Appointments", path: "/", icon: <CalendarOutlined /> },
  { key: "eprescription", label: "E-Prescriptions", path: E_PRESCRIPTIONS_BASE, icon: <MedicineBoxOutlined /> },
  { key: "schedule", label: "Availability", path: "/schedule", icon: <ClockCircleOutlined /> },
  { key: "transactions", label: "Transactions", path: "/transactions", icon: <WalletOutlined /> },
  { key: "profile", label: "Profile", path: "/profile/1", icon: <UserOutlined /> },
];

// Longest-path-prefix match so nested routes (e.g. /eprescription/new,
// /appointments/:id) still highlight their parent nav item, and "/" doesn't
// swallow every other route just because every path starts with it.
export function activeNavKey(pathname: string): string {
  let best: NavItem | null = null;
  for (const item of NAV_ITEMS) {
    const matches =
      item.path === "/"
        ? pathname === "/"
        : pathname === item.path || pathname.startsWith(`${item.path}/`);
    if (matches && (!best || item.path.length > best.path.length)) {
      best = item;
    }
  }
  return best?.key ?? "";
}
